import styled from "styled-components";
import Text from "@streeteasy/design-system/deprecated/Text";
import ExpandableContent from "@streeteasy/design-system/legacy/ExpandableContent";

import { largeScreen } from "src/shared/constants/screenSizes";

const AddSearchPartner = styled(ExpandableContent)`
  margin-top: 15px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
  text-align: left;
`;

const FormContent = styled.div`
  flex: 1 0 auto;
  height: 100px;
  overflow: auto;
  padding: 22px 22px 98px;

  @media (min-width: ${largeScreen}px) {
    padding: 60px;
  }
`;

const TitleContainer = styled.div`
  margin-bottom: 10px;
`;

const CustomLabelText = styled.span`
  font-weight: normal;
  margin-left: 5px;
  text-transform: none;
`;

const TermsOfService = styled(Text).attrs({ type: "disclaimer" })`
  margin: 15px 0 0;
`;

const DisclaimerContainer = styled.div`
  margin-top: 20px;
`;

AddSearchPartner.displayName = "AddSearchPartner";
Form.displayName = "Form";
FormContent.displayName = "FormContent";
TitleContainer.displayName = "TitleContainer";
CustomLabelText.displayName = "CustomLabelText";
TermsOfService.displayName = "TermsOfService";
DisclaimerContainer.displayName = "DisclaimerContainer";

export {
  AddSearchPartner,
  CustomLabelText,
  Form,
  FormContent,
  TitleContainer,
  TermsOfService,
  DisclaimerContainer
};
